<template>
  <div
    class="container-fluid"
    :style="{'background-image': 'url(' + require('../assets/bg3.jpg') + ')','background-size': 'cover'}"
  >
  <nav class="navbar navbar-light bg-dark">
    <img
      src="../assets/technical-support.png"
      width="64"
      height="64"
      class="d-inline-block align-top"
      alt
    >
    <span style="font-size: 60px; line-height: 70px; color: #fff;">Test Hardware Command</span>
    <img src="../assets/cancel.png" width="64" height="64" @click="back">
  </nav>
    <div class="row">
      <div class="col-12 row">
        <div class="col-12" style="height: 30px;"></div>
        <div class="col-3 " style="margin-bottom: 20px;">
          <img src="../assets/donation.png" height="55px" width="55px" @click="openReceive()" />
          <br />
          <span style="font-size: 30px;color: #fff;">OpenReceive</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/cancel.png" height="55px" width="55px" @click="closeReceive()" />
          <br />
          <span style="font-size: 30px;color: #fff;">CloseReceive</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/wallet1.png" height="55px" width="55px" @click="refillmoney()" />
          <br />
          <span style="font-size: 30px;color: #fff;">Refill</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/money-bag.png" height="55px" width="55px" @click="Coun_Count()" />
          <br />
          <span style="font-size: 30px;color: #fff;">Coun_Count</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/money-bag.png" height="55px" width="55px" @click="Coin_Balance()" />
          <br />
          <span style="font-size: 30px;color: #fff;">Coin_Balance</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/money.png" height="55px" width="55px" @click="changeCoinRandom()" />
          <br />
          <span style="font-size: 30px;color: #fff;">ChangeCoinRandom</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/money.png" height="55px" width="55px" @click="changeCoinFix()" />
          <br />
          <span style="font-size: 30px;color: #fff;">ChangeCoinFix</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/money.png" height="55px" width="55px" @click="AcceptedNote()" />
          <br />
          <span style="font-size: 30px;color: #fff;">AcceptedNote</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/receipt.png" height="55px" width="55px" @click="changeNote()" />
          <br />
          <span style="font-size: 30px;color: #fff;">ChangeNote</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/receipt.png" height="55px" width="55px" @click="changeNote2()" />
          <br />
          <span style="font-size: 30px;color: #fff;">ChangeNote2</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/save-money.png" height="55px" width="55px" @click="empty()" />
          <br />
          <span style="font-size: 30px;color: #fff;">Empty</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/opendoor.png" height="55px" width="55px" @click="open_front_door()" />
          <br />
          <span style="font-size: 30px;color: #fff;">OpenDoor</span>
        </div>
        <div class="col-3" style="margin-bottom: 20px">
          <img src="../assets/cashbox.png" height="55px" width="55px" @click="open_cash_box()" />
          <br />
          <span style="font-size: 30px;color: #fff;">OpenCashBox</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import $ from "jquery";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Swal from "sweetalert2";
import api from "../service/services";
export default {
  data() {
    return {
      shift_before: 5423,
      shift_after: 0,
      coins: {
        C10: 0,
        C5: 0,
        C2: 0,
        C1: 0
      }
    };
  },
  computed: {
    ...mapState([
      "UUID",
      "accessToken",
      "AuthenType",
      "status_refill",
      "isLoading"
    ]),
    ...mapMutations(["onMessageWs"])
  },
  methods: {
    back() {
      this.$router.push('/setting')
    },
    openReceive() {
      this.Soundclick()
      console.log("receive_open");
      this.$socket.sendObj({
        command: "receive_open"
      });
    },
    closeReceive() {
      this.Soundclick()
      console.log("receive_close");
      this.$socket.sendObj({
        command: "receive_close"
      });
    },
    refillmoney() {
      this.Soundclick()
      console.log("refill");
      var dataC = '{"v1":10,"v2":100,"v5":100,"v10":100}';
      this.$socket.sendObj({
        Device: "host",
        type: "request",
        command: "refill",
        data: '{"v1":10,"v2":100,"v5":100,"v10":100}'
      });
      console.log(dataC);
    },
    AcceptedNote() {
      this.Soundclick()
      console.log("accepted_note");
      this.$socket.sendObj({
        command: "accepted_note",
        data: 100
      });
    },
    changeCoinRandom() {
      this.Soundclick()
      console.log("change_coin");
      this.$socket.sendObj({
        command: "change_coin",
        data: 50
      });
    },
    changeCoinFix() {
      this.Soundclick()
      console.log("change_coin");
      this.$socket.sendObj({
        command: "change_coins",
        data: '{"c1":1,"c2":0,"c5":1,"c10":1}'
      });
    },
    changeNote() {
      this.Soundclick()
      console.log("change_note");
      this.$socket.sendObj({
        command: "change_note",
        data: 10
      });
    },
    changeNote2() {
      this.Soundclick()
      console.log("change_note2");
      this.$socket.sendObj({
        command: "change_note2",
        data: 10
      });
    },
    empty() {
      this.Soundclick()
      console.log("empty");
      this.$socket.sendObj({
        command: "empty"
      });
    },
    Coun_Count() {
      this.Soundclick()
      console.log("coin_count");
      this.$socket.sendObj({
        command: "coin_count"
      });
    },
    Coin_Balance() {
      this.Soundclick()
      console.log("coin_balance");
      this.$socket.sendObj({
        command: "coin_balance"
      });
    },
    open_front_door() {
      this.Soundclick()
      console.log("open_front_door");
      this.$socket.sendObj({
        command: "open_front_door",
        data: 5
      });
    },
    open_cash_box() {
      this.Soundclick()
      console.log("open_cash_box");
      this.$socket.sendObj({
        command: "open_cash_box",
        data: 5
      });
    }
  },
  mounted() {
    if (!this.accessToken) {
      this.$router.push('/')
    } else {
      this.$socket.sendObj({
        Device: 'host',
        type: 'request',
        command: 'status'
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TestHw.vue